module.exports = __webpack_public_path__ + "static/magazine-2-mobile-d65ec9f5dfa94b3d4025d416b654ba69.jpg";